export default __webpack_public_path__ + "static/media/empty-requests.60027276.svg";